module.exports = __webpack_public_path__ + "mz.svg?4fce86a88ab94af0d4719440a29bbbad";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/mz.svg
// module id = 1527
// module chunks = 0